<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="活动名称：">
                <el-input v-model="formInline.name" placeholder="优惠券名称"></el-input>
            </el-form-item>
            <el-form-item label="创建时间：">
                <el-date-picker
                    v-model="formInline.dateRange"
                    type="datetimerange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="截止时间"
                    style="width: 350px;"
                />
            </el-form-item>
            <el-form-item label="上线状态：">
                <el-select style="width: 150px;" v-model="formInline.status" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未上线" :value="1"></el-option>
                    <el-option label="已上线" :value="2"></el-option>
                    <el-option label="已下线" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="addActivity">新增活动</el-button>
                    <el-button type="primary" @click="getList">搜索</el-button>
                    <el-button type="primary" @click="refresh">刷新</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <!-- <el-table-column label="序号" width="60">
            <template #default="scope">
                <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
        </el-table-column> -->
        <el-table-column label="活动名称" width="180" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.name || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="活动起始时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.startTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="活动截止时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.endTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="应用场站" width="130" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.stationNames || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="活动类型" width="120">
            <template #default="scope">
                <span>{{ activityTypeFormat(scope.row.activityType) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="活动状态" width="120">
            <template #default="scope">
                <span>{{ activityStatusFormat(scope.row.status) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="轮播序号" width="120">
            <template #default="scope">
                <span>{{ scope.row.seq || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.createTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.updateTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
            <template #default="scope">
                <el-button type="primary" @click="editActivity(scope.row.id)">修改</el-button>
                <!-- <el-button type="danger" @click="deleteActivity(scope.row)">删除</el-button> -->
                <el-button v-if="scope.row.status == 1" type="success" @click="toggleOnline(scope.row,true)">上线</el-button>
                <el-button v-if="scope.row.status == 2" type="info" @click="toggleOnline(scope.row,false)">下线</el-button>
                <el-button v-if="scope.row.isBanner == 1" type="warning" @click="openSortDialog(scope.row)">调序</el-button>
            </template>
        </el-table-column>
        <!-- <el-table-column label="上线状态" width="120" fixed="right">
            <template #default="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="2"
                    :inactive-value="1"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change="toggleOnline(scope.row)"
                ></el-switch>
            </template>
        </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 新增/编辑活动弹窗 -->
    <el-dialog v-model="showDialog" :title="isEdit ? '编辑活动' : '新增活动'" :close-on-click-modal="false" width="1120px" @closed="$refs.formRef?.clearValidate()">
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="0" class="activity-form">
            <!-- 上半部分：活动基本信息和活动规则 -->
            <div class="form-top">
                <div class="form-left">
                    <!-- 活动基本信息 -->
                    <div class="form-section">
                        <h3 class="section-title">活动基本信息</h3>
                        <el-form-item prop="name" class="form-row">
                            <label class="form-label">活动名称<span class="required">*</span>:</label>
                            <el-input v-model="formData.name" placeholder="请输入活动名称" class="form-input"></el-input>
                        </el-form-item>
                        <el-form-item prop="titleImage" class="form-row">
                            <label class="form-label">活动标题图片<span class="required">*</span>:</label>
                            <el-upload
                                :action="uploadUrl"
                                :headers="headers"
                                :on-success="(res, file) => handleImageUploadSuccess(res, file, 'title')"
                                :before-upload="beforeAvatarUpload"
                                list-type="picture-card"
                                limit="1"
                                :file-list="titleImageList"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="(file, fileList) => handleImageRemove(file, fileList, 'title')"
                                >
                                <i class="el-icon-plus">+</i>
                            </el-upload>
                            <span class="upload-hint">（仅可上传1张图片，尺寸建议702*200px，大小不超过5MB）</span>
                        </el-form-item>
                        <el-form-item prop="backgroundImage" class="form-row">
                            <label class="form-label">活动主背景图<span class="required">*</span>:</label>
                            <el-upload
                                :action="uploadUrl"
                                :headers="headers"
                                :on-success="(res, file) => handleImageUploadSuccess(res, file, 'background')"
                                :before-upload="beforeAvatarUpload"
                                list-type="picture-card"
                                limit="1"
                                :file-list="backgroundImageList"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="(file, fileList) => handleImageRemove(file, fileList, 'background')">
                                <i class="el-icon-plus">+</i>
                            </el-upload>
                            <span class="upload-hint">（仅可上传1张图片，尺寸建议750*1334px，大小不超过5MB）</span>
                        </el-form-item>
                        <el-form-item prop="dateRange" class="form-row">
                            <label class="form-label">活动时间<span class="required">*</span>:</label>
                            <el-date-picker
                                v-model="formData.dateRange"
                                type="datetimerange"
                                value-format="YYYY-MM-DD HH:mm:ss"
                                range-separator="至"
                                start-placeholder="起始时间"
                                end-placeholder="截止时间"
                                class="form-input-large"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item prop="isBanner" class="form-row">
                            <label class="form-label">是否加入轮播图<span class="required">*</span>:</label>
                            <div class="radio-group">
                                <label class="radio-item">
                                    <input type="radio" v-model="formData.isBanner" :value="1">
                                    <span>是</span>
                                </label>
                                <label class="radio-item">
                                    <input type="radio" v-model="formData.isBanner" :value="0">
                                    <span>否</span>
                                </label>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <!-- 活动规则 -->
                <div class="form-right">
                    <div class="form-section">
                        <el-form-item prop="rules">
                            <label class="form-label">活动规则<span class="required">*</span>:</label>
                            <div style="margin-top: 10px;">
                                <RichEditor v-model="formData.rules" :maxlength="500"></RichEditor>
                            </div>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <!-- 下半部分：活动详情信息 -->
            <div class="form-bottom">
                <div class="form-section">
                    <h3 class="section-title">活动详情信息</h3>
                    <div class="form-row">
                        <label class="form-label">活动类型<span class="required">*</span>:</label>
                        <div class="radio-group">
                            <label class="radio-item">
                                <input type="radio" v-model="formData.activityType" :value="1" @change="handleActivityTypeChange">
                                <span>新用户福利</span>
                            </label>
                            <label class="radio-item">
                                <input type="radio" v-model="formData.activityType" :value="2" @change="handleActivityTypeChange">
                                <span>充电任务奖励</span>
                            </label>
                            <label class="radio-item">
                                <input type="radio" v-model="formData.activityType" :value="3" @change="handleActivityTypeChange">
                                <span>无门槛活动</span>
                            </label>
                        </div>
                    </div>

                    <!-- 福利配置 -->
                    <div v-if="formData.activityType == 1 || formData.activityType == 2 || formData.activityType == 3" class="welfare-section">
                        <div class="form-row">
                            <label class="form-label">活动福利<span class="required">*</span>:</label>
                            <span class="form-hint">（每个活动最多可添加4项福利）</span>
                        </div>

                        <!-- 福利列表 -->
                        <div v-for="(welfare, index) in formData.benefits" :key="index" class="welfare-item">
                            <div class="welfare-header">
                                <span class="welfare-title">福利{{ index + 1 }}</span>
                                <el-button v-if="formData.benefits.length > 1" type="text" @click="removeWelfare(index)" class="remove-btn">×</el-button>
                            </div>

                            <div class="welfare-content">
                                <div class="welfare-left">
                                    <div class="form-row">
                                        <label class="form-label">边框尺寸:</label>
                                        <el-select v-model="welfare.borderSize" class="form-input">
                                            <el-option label="一级边框(690*450px)" :value="1"></el-option>
                                            <el-option label="二级边框(690*300px)" :value="2"></el-option>
                                            <el-option label="三级边框(690*180px)" :value="3"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="form-row">
                                        <label class="form-label">内容图片:</label>
                                        <el-upload
                                            :action="uploadUrl"
                                            :headers="headers"
                                            :on-success="(res, file) => handleContentImageUploadSuccess(res, file, index)"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture-card"
                                            limit="1"
                                            :file-list="getWelfareImageList(index)"
                                            :on-preview="handlePictureCardPreview"
                                            :on-remove="(file, fileList) => handleContentImageRemove(file, fileList, index)">
                                            <i class="el-icon-plus">+</i>
                                        </el-upload>
                                        <span class="upload-hint">（仅可上传1张图片，大小不超过5MB）</span>
                                    </div>
                                    <!-- 充电任务奖励和无门槛活动显示权益发放方式 -->
                                    <div v-if="formData.activityType == 2 || formData.activityType == 3" class="form-row">
                                        <label class="form-label">权益发放方式:</label>
                                        <el-select v-model="welfare.distributionMethod" class="form-input" :disabled="formData.activityType == 3">
                                            <el-option label="满足条件自动发放" :value="1"></el-option>
                                            <el-option label="用户主动领取" :value="2"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="form-row">
                                        <label class="form-label">应用场站:</label>
                                        <el-select v-model="welfare.stationIds" placeholder="请选择" class="form-input" :class="{'station-error': stationErrors[index]}" filterable multiple clearable @change="handleStationIdsChange(index)" collapse-tags collapse-tags-tooltip>
                                            <el-option
                                                v-for="item in stationOptions"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="form-row">
                                        <label class="form-label">目标页面归属:</label>
                                        <el-select v-model="welfare.targetPageType" class="form-input">
                                            <el-option label="请选择" value=""></el-option>
                                            <el-option label="第三方" :value="1"></el-option>
                                            <el-option label="自有小程序" :value="2"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="form-row">
                                        <label class="form-label">目标页面地址:</label>
                                        <el-input v-model="welfare.targetPageUrl" placeholder="请输入目标页面地址" class="form-input"></el-input>
                                    </div>
                                    <div class="form-row">
                                        <label class="form-label">参与限制类型:</label>
                                        <el-select v-model="welfare.participationLimitType" class="form-input">
                                            <el-option label="请选择" value=""></el-option>
                                            <!-- <el-option label="不限制" :value="0"></el-option> -->
                                            <el-option label="仅一次" :value="2"></el-option>
                                            <el-option label="每日限制" :value="3"></el-option>
                                            <el-option label="每周限制" :value="4"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="form-row" v-if="welfare.participationLimitType != 0">
                                        <label class="form-label">参与限制数量:</label>
                                        <el-input v-model="welfare.participationLimitCount" type="number" placeholder="请输入" class="form-input" disabled></el-input>
                                    </div>
                                </div>

                                <div class="welfare-right">
                                    <div class="welfare-issue-header">
                                        <span class="welfare-title">福利发放</span>
                                    </div>

                                    <!-- 新用户福利发放条件 -->
                                    <template v-if="formData.activityType == 1">
                                        <div class="form-row">
                                            <label class="form-label">发放条件:</label>
                                            <el-select v-model="welfare.issueCondition" class="form-input">
                                                <el-option label="新用户注册" :value="3"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="form-row">
                                            <label class="form-label">福利奖励:</label>
                                        </div>
                                        <div class="reward-list">
                                            <div v-for="(reward, rIndex) in welfare.rewards" :key="rIndex" class="reward-item">
                                                <span class="reward-label">送</span>
                                                <el-select v-model="reward.rewardType" class="reward-select" @change="handleRewardTypeChange(index, rIndex)">
                                                    <el-option label="优惠券" :value="1"></el-option>
                                                    <el-option label="兑换券" :value="2"></el-option>
                                                </el-select>
                                                <el-select v-model="reward.couponId" class="reward-select">
                                                    <el-option v-for="coupon in (couponLists[index] && couponLists[index][rIndex] ? couponLists[index][rIndex] : [])" :key="coupon.id" :label="coupon.name" :value="coupon.id"></el-option>
                                                </el-select>
                                                <el-input v-model="reward.quantity" placeholder="请输入" class="reward-input"></el-input>
                                                <span class="reward-unit">张</span>
                                                <el-button type="text" v-if="rIndex > 0" @click="removeReward(index, rIndex)" class="reward-remove">×</el-button>
                                                <el-button type="text" v-if="rIndex == welfare.rewards.length - 1 && welfare.rewards.length < 5" @click="addReward(index)" class="reward-add">+</el-button>
                                            </div>
                                        </div>
                                        <span class="reward-hint">（最多可添加5项）</span>
                                    </template>

                                    <!-- 充电任务奖励发放条件 -->
                                    <template v-if="formData.activityType == 2">
                                        <div class="form-row">
                                            <label class="form-label">发放条件:</label>
                                            <el-select v-model="welfare.issueCondition" class="form-input" @change="handleIssueConditionChange(index)">
                                                <el-option label="单次充电消费满额" :value="1"></el-option>
                                                <el-option label="累计充电消费满额" :value="2"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="form-row">
                                            <label class="form-label">福利奖励:</label>
                                        </div>
                                        <!-- 满额条件与福利奖励组合列表 -->
                                        <div class="welfare-rule-list">
                                            <div v-for="(rule, ruleIndex) in welfare.rewards" :key="ruleIndex" class="welfare-rule-item">
                                                <!-- 满额条件 -->
                                                <span class="condition-label">满</span>
                                                <el-input v-model="rule.conditionAmount" placeholder="请输入" class="condition-input"></el-input>
                                                <span class="condition-unit">元</span>
                                                <!-- 福利奖励 -->
                                                <span class="reward-label">赠</span>
                                                <el-select v-model="rule.rewardType" class="reward-select" @change="handleRewardTypeChange(index, ruleIndex)">
                                                    <el-option label="优惠券" :value="1"></el-option>
                                                    <el-option label="兑换券" :value="2"></el-option>
                                                </el-select>
                                                <el-select v-model="rule.couponId" class="reward-select">
                                                    <el-option v-for="coupon in (couponLists[index] && couponLists[index][ruleIndex] ? couponLists[index][ruleIndex] : [])" :key="coupon.id" :label="coupon.name" :value="coupon.id"></el-option>
                                                </el-select>
                                                <el-input v-model="rule.quantity" placeholder="请输入" class="reward-input"></el-input>
                                                <span class="reward-unit">张</span>
                                                <!-- 删除按钮 -->
                                                <el-button v-if="welfare.rewards.length > 1" type="text" @click="removeRule(index, ruleIndex)" class="rule-remove">×</el-button>
                                                <!-- 添加按钮（只在最后一行显示） -->
                                                <el-button v-if="ruleIndex == welfare.rewards.length - 1 && welfare.rewards.length < 5" type="text" @click="addRule(index)" class="rule-add">+</el-button>
                                            </div>
                                        </div>
                                        <span class="reward-hint">（最多可添加5项）</span>
                                    </template>

                                    <!-- 无门槛活动发放条件 -->
                                    <template v-if="formData.activityType == 3">
                                        <div class="form-row">
                                            <label class="form-label">发放条件:</label>
                                            <el-select v-model="welfare.issueCondition" class="form-input">
                                                <el-option label="无条件" :value="3"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="form-row">
                                            <label class="form-label">福利奖励:</label>
                                        </div>
                                        <div class="reward-list">
                                            <div v-for="(reward, rIndex) in welfare.rewards" :key="rIndex" class="reward-item">
                                                <span class="reward-label">送</span>
                                                <el-select v-model="reward.rewardType" class="reward-select" @change="handleRewardTypeChange(index, rIndex)">
                                                    <el-option label="优惠券" :value="1"></el-option>
                                                    <el-option label="兑换券" :value="2"></el-option>
                                                </el-select>
                                                <el-select v-model="reward.couponId" class="reward-select">
                                                    <el-option v-for="coupon in (couponLists[index] && couponLists[index][rIndex] ? couponLists[index][rIndex] : [])" :key="coupon.id" :label="coupon.name" :value="coupon.id"></el-option>
                                                </el-select>
                                                <el-input v-model="reward.quantity" placeholder="请输入数字" class="reward-input"></el-input>
                                                <span class="reward-unit">张</span>
                                                <el-button type="text" v-if="rIndex > 0" @click="removeReward(index, rIndex)" class="reward-remove">×</el-button>
                                                <el-button type="text" v-if="rIndex == welfare.rewards.length - 1 && welfare.rewards.length < 5" @click="addReward(index)" class="reward-add">+</el-button>
                                            </div>
                                        </div>
                                        <span class="reward-hint">（最多可添加5项）</span>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!-- 添加福利按钮 -->
                        <div v-if="formData.benefits.length < 4" class="add-welfare-btn">
                            <el-button type="primary" @click="addWelfare">+ 添加福利</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>

        <template #footer>
            <div class="footer-buttons">
                <el-button @click="showDialog = false">返回</el-button>
                <el-button type="primary" @click="submitForm">保存</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 图片预览弹窗 -->
    <el-dialog v-model="dialogVisible" title="图片预览" :close-on-click-modal="false">
        <img :src="dialogImageUrl" style="width: 100%;" />
    </el-dialog>

    <!-- 调整轮播序号弹窗 -->
    <el-dialog v-model="showSortDialog" title="调整轮播序号" :close-on-click-modal="false" width="400px">
        <el-form :model="sortForm" label-width="100px">
            <el-form-item label="轮播序号：">
                <el-input v-model.number="sortForm.seq" type="number" placeholder="请输入轮播序号" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="footer-buttons">
                <el-button @click="showSortDialog = false">取消</el-button>
                <el-button type="primary" @click="submitSort">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import RichEditor from '@/components/RichEditor.vue'
import { required, isNumberValue } from '@/utils/validators';
export default {
    name:'ActivityManagement',
    components: {
    RichEditor
},
data() {
    return {
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        showDialog: false,
        isEdit: false,
        formRef: null,
        stationErrors: {}, // 存储每个福利项的场站验证错误状态
        formRules: {
            name: [required('请输入活动名称')],
            titleImage: [required('请上传活动标题图片')],
            backgroundImage: [required('请上传活动主背景图')],
            dateRange: [required('请选择活动时间')],
            isBanner: [required('请选择是否加入轮播图')],
            rules: [required('请输入活动规则')],
        },
        formData: {
            id: '',
            name: '',
            activityType: '',
            dateRange: [],
            rules: '',
            titleImage: '',
            backgroundImage: '',
            benefits: [{ // 默认一个福利
                borderSize: 2,
                contentImage: '',
                targetPageType: '',
                targetPageUrl: '',
                participationLimitType: '',
                participationLimitCount:'',
                distributionMethod: 1,
                issueCondition: '',
                stationIds: [],
                rewards: [{ rewardType: 1, couponId: '', quantity: '' }]
            }]
        },
        formInline: {
            name: '',
            dateRange: [],
            status: ''
        },
        stationOptions: [],
        couponLists: [], // 存储每个福利项的优惠券列表，结构：couponLists[welfareIndex][rewardIndex] = [{id, name}, ...]
        // 图片上传相关
        uploadUrl: process.env.NODE_ENV === 'development' ? '/api' + this.$store.state.platformApi + "oss/upload" : process.env.VUE_APP_API_URL + '/' + this.$store.state.platformApi + "oss/upload",
        headers: {
            'Authorization': localStorage.getItem('token')
        },
        // 图片预览
        dialogImageUrl: '',
        dialogVisible: false,
        // 调序弹窗
        showSortDialog: false,
        sortForm: {
            id: '',
            seq: 0
        },

    }
},
mounted(){
    this.getList();
    this.getStationOptions();
},
watch: {
    '$store.state.stationList': {
        handler(newVal) {
            if (newVal && newVal.length > 0) {
                this.stationOptions = newVal;
            }
        },
        immediate: true
    }
},

methods:{
    getStationOptions(){
        let that = this;
        that.stationOptions = that.$store.state.stationList || [];
    },
    getList(){
        let that = this;
        let param = {
            page: that.currentPage,
            pageSize: that.pageSize
        };
        Object.keys(this.formInline).forEach(key => {
            if(this.formInline[key]){
                if(key === 'dateRange' && this.formInline.dateRange.length === 2){
                    param.createTimeStart = this.formInline.dateRange[0];
                    param.createTimeEnd = this.formInline.dateRange[1];
                } else if(key !== 'dateRange'){
                    param[key] = this.formInline[key];
                }
            }
        });
        
        that.$axios.post(that.$store.state.platformApi + "charge/activity/page", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.tableData = result.data.records;
                that.total = result.data.total;
            }
        });
    },
    handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    refresh() {
        this.formInline = {
            name: '',
            dateRange: [],
            status: ''
        };
        this.currentPage = 1;
        this.getList();
    },
    handleActivityTypeChange(){
        this.stationErrors = {};
        this.couponLists = [];
        // 无门槛活动时，权益发放方式默认为用户主动领取(2)，其他类型为满足条件自动发放(1)
        const defaultDistributionMethod = this.formData.activityType == 3 ? 2 : 1;
        this.formData.benefits = [{ // 默认一个福利
            borderSize: 2,
            contentImage: '',
            targetPageType: '',
            targetPageUrl: '',
            participationLimitType: '',
            participationLimitCount: 1,
            distributionMethod: defaultDistributionMethod,
            issueCondition: this.formData.activityType == 2 ? 1 : 3,
            stationIds: [],
            rewards: [{ rewardType: 1, couponId: '', quantity: '' }]
        }];
    },
    addActivity() {
        this.isEdit = false;
        this.formData = {
            id: '',
            name: '',
            activityType: '',
            dateRange: [],
            isBanner: 0,
            rules: '',
            titleImage: '',
            backgroundImage: '',
            benefits: [{ // 默认一个福利
                borderSize: 2,
                contentImage: '',
                targetPageType: '',
                targetPageUrl: '',
                participationLimitType:'',
                participationLimitCount: 1,
                distributionMethod: 1,
                issueCondition: '',
                stationIds: [],
                rewards: [{ rewardType: 1, couponId: '', quantity: '' }]
            }]
        };
        // 重置图片列表
        this.titleImageList = [];
        this.backgroundImageList = [];
        this.stationErrors = {};
        this.couponLists = [];
        this.showDialog = true;
    },
    // 获取优惠券列表
    getCouponList(stationIds, couponType, welfareIndex, rewardIndex) {
        let that = this;
        let param = {};
        param.stationIds = stationIds || [];
        param.couponType = couponType || 1;
        that.$axios.post(that.$store.state.platformApi + "charge/coupon/selected", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                let list = result.data || [];
                if(!Array.isArray(list)){
                    list = [];
                }
                // 创建新的外层数组副本，替换整个引用确保Vue 3响应式触发
                let newCouponLists = [...that.couponLists];
                if(!newCouponLists[welfareIndex]){
                    newCouponLists[welfareIndex] = [];
                } else {
                    newCouponLists[welfareIndex] = [...newCouponLists[welfareIndex]];
                }
                newCouponLists[welfareIndex][rewardIndex] = list;
                that.couponLists = newCouponLists;
            }
        });
    },
    // 当应用场站变化时，刷新该福利项的所有奖励的优惠券列表
    handleStationIdsChange(welfareIndex) {
        let that = this;
        let welfare = that.formData.benefits[welfareIndex];
        // 过滤掉空值
        let stationIds = (welfare.stationIds || []).filter(id => id !== '' && id != null);
        
        // 清除错误状态
        let newErrors = { ...that.stationErrors };
        delete newErrors[welfareIndex];
        that.stationErrors = newErrors;
        
        if(stationIds.length > 0 && welfare.rewards && welfare.rewards.length > 0){
            welfare.rewards.forEach((reward, rIndex) => {
                that.getCouponList(stationIds, reward.rewardType, welfareIndex, rIndex);
            });
        }
    },
    // 当奖励类型变化时，刷新该奖励的优惠券列表
    handleRewardTypeChange(welfareIndex, rewardIndex) {
        let that = this;
        let welfare = that.formData.benefits[welfareIndex];
        let reward = welfare.rewards[rewardIndex];
        let stationIds = (welfare.stationIds || []).filter(id => id !== '' && id != null);
        let couponType = reward.rewardType || 1;

        //如果场站为空，设置错误状态并返回
        if(stationIds.length == 0){
            that.stationErrors = { ...that.stationErrors, [welfareIndex]: true };
            that.$message.error('请先选择场站');
            return;
        }
        
        // 清除错误状态
        that.stationErrors = { ...that.stationErrors };
        delete that.stationErrors[welfareIndex];
        that.getCouponList(stationIds, couponType, welfareIndex, rewardIndex);
    },
    // 获取活动详情
    editActivity(aid) {
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "charge/activity/detail/"+aid, {}).then(result => {
            if(result.code == 200){
                that.setInfo(result.data);
            }
        });
    },
    setInfo(row) {
        this.isEdit = true;
        this.formData = {
            id: row.id,
            name: row.name,
            activityType: row.activityType,
            dateRange: row.startTime && row.endTime ? [row.startTime+':00', row.endTime+':00'] : [],
            rules: row.rules || '',
            titleImage: row.titleImage || '',
            backgroundImage: row.backgroundImage || '',
            isBanner: row.isBanner || 0,
            benefits: row.benefits || [{
                borderSize: 2,
                contentImage: '',
                targetPageType: '',
                targetPageUrl: '',
                participationLimitType:'',
                participationLimitCount:'',
                distributionMethod: 1,
                issueCondition: '',
                stationIds: [],
                rewards: [{ rewardType: 1, couponId: '', quantity: '' }]
            }]
        };
        // 特殊字段处理
        this.formData.benefits.forEach(item => {
            if(item.rewards && item.rewards.length > 0){
                item.issueCondition = item.rewards[0].benefitCondition || '';
            }else{
                // 添加默认项
                item.rewards = [{ rewardType: 1, couponId: '', quantity: '' }];
            }
            // 无门槛活动时，权益发放方式强制设置为用户主动领取(2)
            if(this.formData.activityType == 3){
                item.distributionMethod = 2;
            }
        });
        // 初始化图片列表
        this.titleImageList = row.titleImage ? [{ url: row.titleImage }] : [];
        this.backgroundImageList = row.backgroundImage ? [{ url: row.backgroundImage }] : [];
        // 加载优惠券列表数据
        this.$nextTick(() => {
            this.formData.benefits.forEach((benefit, welfareIndex) => {
                let stationIds = (benefit.stationIds || []).filter(id => id !== '' && id != null);
                if(stationIds.length > 0 && benefit.rewards && benefit.rewards.length > 0){
                    benefit.rewards.forEach((reward, rewardIndex) => {
                        this.getCouponList(stationIds, reward.rewardType || 1, welfareIndex, rewardIndex);
                    });
                }
            });
        });
        this.showDialog = true;
    },
    deleteActivity(row) {
        let that = this;
        that.$confirm('确定要删除该活动吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "activity/delete/"+row.id, {}).then(result => {
                if(result.code == 200){
                    that.$message.success('删除成功');
                    that.getList();
                }
            });
        }).catch(() => {
            that.$message.info('已取消删除');
        });
    },
    toggleOnline(row,flag) {
        //先弹窗确认
        let that = this;
        that.$confirm(flag ? '确定上线该活动吗？' : '确定下线该活动吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            // 发送请求
            let url = flag ? "charge/activity/online" : "charge/activity/offline";
            that.$axios.post(that.$store.state.platformApi + url + "/" + row.id, {}).then(result => {
                if(result.code == 200){
                    row.status = flag ? 2 : 3;
                    that.$message.success(flag ? '已上线' : '已下线');
                }
            });
        }).catch(() => {
            that.$message.info('已取消操作');
        });
    },
    submitForm() {
        let that = this;
        // 使用 el-form 校验
        this.$refs.formRef.validate((valid) => {
            if (!valid) return;
            // 校验活动类型
            if(!that.formData.activityType){
                that.$message.error('请选择活动类型');
                return;
            }
            // 处理活动时间
            that.formData.startTime = that.formData.dateRange[0];
            that.formData.endTime = that.formData.dateRange[1];
            // 校验福利项
            if(that.formData.benefits && that.formData.benefits.length > 0){
                for(let i = 0; i < that.formData.benefits.length; i++){
                    let item = that.formData.benefits[i];
                    // 校验参与限制数量
                    if(item.participationLimitType && item.participationLimitType != 0 && !item.participationLimitCount){
                        that.$message.error('请输入福利' + (i+1) + '的参与限制数量');
                        return;
                    }
                    if(item.participationLimitCount && !isNumberValue(item.participationLimitCount)){
                        that.$message.error('福利' + (i+1) + '的参与限制数量只能输入数字');
                        return;
                    }
                    // 校验奖励
                    if(item.rewards && item.rewards.length > 0){
                        for(let j = 0; j < item.rewards.length; j++){
                            let reward = item.rewards[j];
                            if(!reward.couponId){
                                that.$message.error('请选择福利' + (i+1) + '的奖励' + (j+1) + '的优惠券');
                                return;
                            }
                            if(!reward.quantity){
                                that.$message.error('请输入福利' + (i+1) + '的奖励' + (j+1) + '的数量');
                                return;
                            }
                            if(!isNumberValue(reward.quantity)){
                                that.$message.error('福利' + (i+1) + '的奖励' + (j+1) + '的数量只能输入数字');
                                return;
                            }
                            //issueCondition字段赋值到rewards数组的每个元素新增benefitCondition字段
                            reward.benefitCondition = item.issueCondition;
                        }
                    }
                }
            }
            // 提交数据
            let url = that.isEdit ? "charge/activity/update" : "charge/activity/add";
            that.$axios.post(that.$store.state.platformApi + url, JSON.stringify(that.formData)).then(result => {
                if(result.code == 200){
                    that.$message.success(that.isEdit ? '修改成功' : '新增成功');
                    that.showDialog = false;
                    that.getList();
                }
            });
        });
    },
    activityTypeFormat(type){
        switch(type){
            case 1:
                return '新用户福利';
            case 2:
                return '充电任务奖励';
            case 3:
                return '无门槛活动';
            case 4:
                return '充值奖励';
            default:
                return '-';
        }
    },
    activityStatusFormat(status){
        switch(status){
            case 1:
                return '未上线';
            case 2:
                return '已上线';
            case 3:
                return '已下线';
            default:
                return '-';
        }
    },
    // 图片上传成功处理
    handleImageUploadSuccess(res, file, type) {
        if (res.code == 200) {
            const imageUrl = res.data.url;
            if (type === 'title') {
                this.formData.titleImage = imageUrl;
                this.titleImageList = [{ url: imageUrl }];
            } else if (type === 'background') {
                this.formData.backgroundImage = imageUrl;
                this.backgroundImageList = [{ url: imageUrl }];
            }
        }
    },
    // 福利内容图片上传成功处理
    handleContentImageUploadSuccess(res, file, index) {
        if (res.code == 200) {
            this.formData.benefits[index].contentImage = res.data.url;
        }
    },
    // 图片删除处理
    handleImageRemove(file, fileList, type) {
        if (type === 'title') {
            this.formData.titleImage = '';
            this.titleImageList = fileList;
        } else if (type === 'background') {
            this.formData.backgroundImage = '';
            this.backgroundImageList = fileList;
        }
    },
    // 福利内容图片删除处理
    handleContentImageRemove(file, fileList, index) {
        this.formData.benefits[index].contentImage = '';
    },
    // 获取福利图片列表
    getWelfareImageList(index) {
        const url = this.formData.benefits[index].contentImage;
        return url ? [{ url: url }] : [];
    },
    // 图片预览
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    // 打开调序弹窗
    openSortDialog(row) {
        this.sortForm = {
            id: row.id,
            seq: row.seq || 0
        };
        this.showSortDialog = true;
    },
    // 提交调序
    submitSort() {
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "charge/activity/banner/seq", { seq: that.sortForm.seq, id: that.sortForm.id }).then(result => {
            if (result.code === 200) {
                that.$message.success('调序成功');
                that.showSortDialog = false;
                that.getList();
            }
        });
    },
    // 上传前验证
    beforeAvatarUpload(file) {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            this.$message.error('请上传图片文件');
            return false;
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.$message.error('上传图片大小不能超过 5MB');
            return false;
        }
        return true;
    },
    addWelfare() {
        if(this.formData.benefits.length < 4){
            let activityType = this.formData.activityType;
            // 无门槛活动时，权益发放方式默认为用户主动领取(2)
            let defaultDistributionMethod = activityType == 3 ? 2 : 1;
            this.formData.benefits.push({
                borderSize: 2,
                contentImage: '',
                stationIds: [],
                targetPageType: '',
                targetPageUrl: '',
                participationLimitType:'',
                participationLimitCount: 1,
                distributionMethod: defaultDistributionMethod,
                issueCondition: activityType == 2 ? 1 : 3,
                rewards: [{ conditionAmount: '', rewardType: 1, couponId: '', quantity: '' }]
            });
        }
    },
    addRule(welfareIndex) {
        let welfare = this.formData.benefits[welfareIndex];
        if(welfare.rewards.length < 5){
            let newIndex = welfare.rewards.length;
            welfare.rewards.push({ conditionAmount: '', rewardType: 1, couponId: '', quantity: '' });
            // 新增行后自动加载优惠券列表
            let stationIds = (welfare.stationIds || []).filter(id => id !== '' && id != null);
            if(stationIds.length > 0){
                this.getCouponList(stationIds, 1, welfareIndex, newIndex);
            }
        }
    },
    removeRule(welfareIndex, ruleIndex) {
        let welfare = this.formData.benefits[welfareIndex];
        if(welfare.rewards.length > 1){
            welfare.rewards.splice(ruleIndex, 1);
        }
    },
    removeWelfare(index) {
        if(this.formData.benefits.length > 1){
            this.formData.benefits.splice(index, 1);
        }
    },
    addReward(welfareIndex) {
        let welfare = this.formData.benefits[welfareIndex];
        if(welfare.rewards.length < 5){
            let newIndex = welfare.rewards.length;
            welfare.rewards.push({ rewardType: 1, couponId: '', quantity: '' });
            // 新增行后自动加载优惠券列表
            let stationIds = (welfare.stationIds || []).filter(id => id !== '' && id != null);
            if(stationIds.length > 0){
                this.getCouponList(stationIds, 1, welfareIndex, newIndex);
            }
        }
    },
    removeReward(welfareIndex, rewardIndex) {
        let welfare = this.formData.benefits[welfareIndex];
        if(welfare.rewards.length > 1){
            welfare.rewards.splice(rewardIndex, 1);
        }
    },
    handleIssueConditionChange(welfareIndex) {
        let welfare = this.formData.benefits[welfareIndex];
        if(welfare.issueCondition === 2){
            welfare.participationLimitType = 2;
        }
    }
}
}
</script>

<style lang="scss" scoped>
.search_nav{
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
}
.button_group{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button{
        margin-left: 10px;
    }
}

/* 活动弹窗样式 */
.activity-form {
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 100%;
}

.form-top {
    display: flex;
    gap: 25px;
}

.form-left {
    flex: 1.1;
    min-width: 450px;
}

.form-right {
    flex: 0.9;
    min-width: 400px;
    display: flex;
    flex-direction: column;
}

.form-bottom {
    width: 100%;
}

.form-section {
    margin-bottom: 20px;
}

.section-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 15px;
    margin-bottom: 15px;
}

.form-label {
    font-size: 13px;
    color: #666;
    min-width: 100px;
    padding-top: 8px;
}

.required {
    color: #f56c6c;
}

.form-input {
    width: 250px;
}

.station-error {
    ::v-deep(.el-select__wrapper) {
        box-shadow: 0 0 0 1px #f56c6c inset !important;
    }
}

.form-input-small {
    width: 200px;
}

.form-input-large {
    width: 380px;
}

.upload-box {
    width: 200px;
    height: 100px;
}

.upload-placeholder {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #fafafa;
    transition: all 0.3s;

    &:hover {
        border-color: #409eff;
        background: #f0f5ff;
    }
}

.upload-icon {
    font-size: 30px;
    color: #ccc;
    margin-bottom: 5px;
}

.upload-text {
    font-size: 11px;
    color: #999;
    text-align: center;
    line-height: 1.4;
}

.radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding-top: 5px;
}

.radio-item {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    font-size: 13px;
    color: #333;

    input {
        margin: 0;
    }
}

.form-hint {
    font-size: 12px;
    color: #999;
}

.welfare-section {
    margin-top: 20px;
    padding: 15px;
    background: #fafafa;
    border-radius: 4px;
}

.welfare-item {
    margin-bottom: 20px;
    padding: 15px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: hidden;
}

.welfare-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.welfare-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.remove-btn {
    color: #999;
    font-size: 20px;
    padding: 0;
    width: 24px;
    height: 24px;
    line-height: 20px;
}

.welfare-content {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.welfare-left {
    flex: 1;
    min-width: 280px;
    padding-right: 20px;
    border-right: 1px solid #eee;
}

.welfare-right {
    flex: 1;
    min-width: 280px;
}

.welfare-issue-header {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.upload-box-large {
    width: 250px;
    height: 150px;
}

.reward-list {
    margin-bottom: 10px;
}

.reward-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.reward-label {
    font-size: 13px;
    color: #666;
}

.reward-select {
    width: 120px;
}

.reward-input {
    width: 80px;
}
.condition-input {
    width: 80px;
    margin: 0 10px;
}

.reward-unit {
    font-size: 13px;
    color: #666;
}

.reward-remove,
.reward-add {
    color: #999;
    font-size: 18px;
    padding: 0;
    width: 24px;
    height: 24px;
    line-height: 20px;
}

.reward-add {
    color: #409eff;
}

.reward-hint {
    font-size: 12px;
    color: #999;
}

.add-welfare-btn {
    margin-top: 15px;
    text-align: center;
}

.rule-textarea {
    width: 100%;
    flex: 1;
    min-height: 350px;
    resize: none;
    margin-top: 8px;
}

.footer-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 15px;

    button {
        width: 100px;
    }
}
.welfare-config-row {
    display: flex;
    justify-content: space-between;
}

.condition-list {
    flex: 1;
    margin-right: 20px;
}

.reward-list {
    flex: 1;
}

.reward-label {
    margin-left: 40px;
}
.welfare-rule-list {
    margin-top: 10px;
}

.welfare-rule-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    gap: 5px;
}

.rule-remove,
.rule-add {
    color: #999;
    font-size: 18px;
    padding: 0;
    width: 24px;
    height: 24px;
    line-height: 22px;
    text-align: center;
}

.rule-add {
    color: #409EFF;
}
</style>